var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { selectAllItems, selectItem, unselectItem, updateSelection } from "./helpers";
export var resultReducer = function (state, action) {
    var _a;
    switch (action.type) {
        case "SET_RESULT":
            return __assign(__assign({}, state), { selection: ((_a = action.options) === null || _a === void 0 ? void 0 : _a.noSelectionUpdate)
                    ? state.selection
                    : updateSelection(state.selection, state.result.searchResult, action.payload.searchResult), result: __assign(__assign({}, state.result), action.payload) });
        case "SELECT_LIST_ITEM":
            return __assign(__assign({}, state), { selection: selectItem(action.payload.selection, state.selection, state.result.data, state.result.placards, state.result.galleryItems, action.payload.resultIdMatchesListId) });
        case "UNSELECT_LIST_ITEM":
            return __assign(__assign({}, state), { selection: unselectItem(action.payload, state.selection) });
        case "SELECT_ALL_LIST_ITEMS":
            return __assign(__assign({}, state), { selection: selectAllItems(state.result.searchResult) });
        case "UNSELECT_ALL_LIST_ITEMS":
            return __assign(__assign({}, state), { selection: [] });
    }
    return state;
};
//# sourceMappingURL=result-reducer.js.map